import { Component, computed, effect, input, output, viewChild } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Dictionary } from '@ngrx/entity/src/models';
import { UiButtonComponent } from '@ui';

import { EdgeCamera } from '../../../../../cameras/camera.model';
import { CameraPickerInlineComponent } from '@modals/camera-picker-inline/camera-picker-inline.component';
import { CameraPickerModels } from '@modals/camera-picker-inline/models/models';
import { IntelligenceModels } from '@models/intelligence.model';

@Component({
  selector: 'app-pick-camera-result',
  standalone: true,
  imports: [TranslatePipe, CameraPickerInlineComponent, UiButtonComponent],
  templateUrl: './pick-camera-result.component.html',
  styleUrl: './pick-camera-result.component.scss',
})
export class PickCameraResultComponent {
  public readonly request = input<IntelligenceModels.Locations.PickCameraResult | null>(null);
  public readonly cameraPicked = output<IntelligenceModels.Locations.PickCameraSelection>();
  public readonly camerasPicked = output<IntelligenceModels.Locations.PickCamerasSelection>();

  protected readonly cameraPicker = viewChild(CameraPickerInlineComponent);
  protected readonly selectedValue: EdgeCamera.CameraItem[] = [];
  protected readonly pickerOptions = computed<CameraPickerModels.Options>(() =>
    this.request()?.multi
      ? {
          multi: true,
          emitOnSelect: false,
          edgeCameraEnabled: true,
          inline: true,
          selectedValueInputType: CameraPickerModels.SelectedCameraInputType.EdgeItem,
        }
      : {
          multi: false,
          emitOnSelect: true,
          edgeCameraEnabled: true,
          inline: true,
          selectAndClose: true,
          selectedValueInputType: CameraPickerModels.SelectedCameraInputType.EdgeItem,
        },
  );

  public constructor() {
    effect(() => {
      const cameraPicker = this.cameraPicker();
      const query = this.request()?.query ?? '';
      cameraPicker?.searchLocations(query);
    });
  }

  protected onCameraSelected(
    selectedCameras: Dictionary<CameraPickerModels.SelectedCamera>,
  ): void {
    if (this.request()?.multi) {
      const cameras: IntelligenceModels.Locations.PickCameraSelection[] = [];
      for (const selectedCamera of Object.values(selectedCameras)) {
        const cameraName = selectedCamera?.edgeCamera?.edgeOnly?.name ?? selectedCamera?.name;
        if (!selectedCamera?.cameraId || !cameraName) continue;
        cameras.push({
          cameraId: selectedCamera.cameraId,
          cameraName,
        });
      }
      this.camerasPicked.emit({ cameras });
      return;
    }

    const selectedCamera = Object.values(selectedCameras)[0];
    const cameraName = selectedCamera?.edgeCamera?.edgeOnly?.name ?? selectedCamera?.name;
    if (!selectedCamera?.cameraId || !cameraName) return;

    this.cameraPicked.emit({
      cameraId: selectedCamera.cameraId,
      cameraName,
    });
  }

  protected saveCameras(): void {
    this.cameraPicker()?.save();
  }

  protected skipCameras(): void {
    this.camerasPicked.emit({ cameras: [] });
  }
}
